import React, { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../AuthContext';
import { getDeliveredHistory } from '../api';
import { Header, Loader, StatusBadge } from '../components';
import { IconHome, IconPhone, IconPerson, IconClock } from '../Icons';

const parseTime = (time) => {
  if (!time) return '';
  const parts = time.split(' ');
  if (parts.length < 2) return time;
  const timeParts = parts[1].split(':');
  return `${parts[0]} | ${timeParts[0]}:${timeParts[1]}`;
};

const OrdersHistoryScreen = ({ navigate }) => {
  const { courierId, organizationId } = useAuth();
  const [data, setData] = useState([]);
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const result = await getDeliveredHistory();
      if (result.message) {
        setData([]);
        setMessage(result.message);
      } else {
        setData(Array.isArray(result) ? result : []);
        setMessage('');
      }
    } catch {
      setMessage('Ошибка загрузки.');
    } finally {
      setLoading(false);
    }
  }, [courierId, organizationId]);

  useEffect(() => { load(); }, [load]);

  const goToOrder = (item) => {
    navigate('order', { orderId: item.id, orgId: item.organizationId, number: item.order.number, from: 'history' });
  };

  return (
    <>
      <Header
        title="История доставок"
        onBack={() => navigate('list')}
      />
      <div className="screen">
        <div className="screen-content">
          {loading ? (
            <Loader />
          ) : message ? (
            <div className="empty-state">{message}</div>
          ) : data.length === 0 ? (
            <div className="empty-state">История пуста</div>
          ) : (
            data.map((item) => (
              <div key={item.id} className="order-card" onClick={() => goToOrder(item)}>
                <div className="order-number">Заказ №{item.order.number}</div>
                <div className="order-row">
                  <IconHome />
                  <span>
                    {item.order.deliveryPoint?.address?.line1}
                    {/* г.&nbsp;{item.order.deliveryPoint?.address.street.city.name},&nbsp;
                    ул.&nbsp;{item.order.deliveryPoint?.address.street.name}&nbsp;
                    {item.order.deliveryPoint?.address.building},&nbsp;
                    кв.&nbsp;{item.order.deliveryPoint?.address.house} */}
                  </span>
                </div>
                <div className="order-row">
                  <IconPhone />
                  <span>{item.order.phone}</span>
                </div>
                <div className="order-row">
                  <IconPerson />
                  <span>{item.order.customer?.name}</span>
                </div>
                <div className="order-last-row">
                  <div className="order-row" style={{ marginBottom: 0 }}>
                    <IconClock />
                    <span>{parseTime(item.order.cookingStartTime)}</span>
                  </div>
                  <StatusBadge status={item.order.status} />
                </div>
              </div>
            ))
          )}

          {!loading && (
            <div className="pull-hint" onClick={load}>↻ Обновить</div>
          )}
        </div>
      </div>
    </>
  );
};

export default OrdersHistoryScreen;
